import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
export const HTMLText = ({ text, sx = {}, variant = 'body1', strip = false, wrap = false }) => {
    if (!text)
        return null;
    let cleanText = text;
    if (strip) {
        cleanText = cleanText.replace(/<[^>]*>?/gm, '');
    }
    else if (wrap) {
        return _jsx(Box, { sx: sx, dangerouslySetInnerHTML: { __html: cleanText } });
    }
    return _jsx(Typography, { variant: variant, sx: sx, dangerouslySetInnerHTML: { __html: cleanText } });
};
